import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/olympiq-logo.svg';
import {
  WHATSAPP_URL,
  INSTAGRAM_URL,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL,
} from '../../utils/siteLinks';
import { IOS_APP_STORE_URL, ANDROID_PLAY_STORE_URL } from '../../utils/appStoreRedirect';
import './siteFooter.css';

const SiteFooter = (): React.JSX.Element => (
  <footer className="oq-footer">
    <div className="oq-container oq-footer__inner">
      <div className="oq-footer__grid">
        <div className="oq-footer__brand">
          <div className="oq-footer__brand-row">
            <img src={logo} alt="Olympiq" width={36} height={36} className="oq-footer__logo" />
            <span className="oq-bebas oq-footer__wordmark">OLYMPIQ</span>
          </div>
          <p className="oq-footer__tagline">
            The all-in-one club management software for UK sports clubs. Session booking,
            membership and payments in one modern club app.
          </p>
        </div>

        <div className="oq-footer__column">
          <div className="oq-bebas oq-footer__heading">PRODUCT</div>
          <div className="oq-footer__links">
            <Link to="/#features" className="oq-footer__link">Features</Link>
            <Link to="/#website" className="oq-footer__link">Club websites</Link>
            <Link to="/compare" className="oq-footer__link">Compare</Link>
          </div>
        </div>

        <div className="oq-footer__column">
          <div className="oq-bebas oq-footer__heading">RESOURCES</div>
          <div className="oq-footer__links">
            <Link to="/help-centre" className="oq-footer__link">Help centre</Link>
            <Link to="/help-centre/booking-a-session" className="oq-footer__link">Booking a session</Link>
            <Link to="/help-centre/creating-a-session" className="oq-footer__link">Creating a session</Link>
          </div>
        </div>

        <div className="oq-footer__column">
          <div className="oq-bebas oq-footer__heading">CLUB</div>
          <div className="oq-footer__links">
            <Link to="/contact-us" className="oq-footer__link">Contact us &amp; book a demo</Link>
            <a
              href={WHATSAPP_URL}
              className="oq-footer__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="oq-footer__bottom">
        <span className="oq-footer__copyright">
          © 2026 Olympiq Ltd. Club management software for UK sports clubs.
        </span>
        <div className="oq-footer__bottom-links">
          <a
            href={PRIVACY_POLICY_URL}
            className="oq-footer__bottom-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href={COOKIE_POLICY_URL}
            className="oq-footer__bottom-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>
          <a
            href={IOS_APP_STORE_URL}
            className="oq-footer__bottom-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            App Store
          </a>
          <a
            href={ANDROID_PLAY_STORE_URL}
            className="oq-footer__bottom-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Play
          </a>
        </div>
        <div className="oq-footer__socials">
          <a
            href={INSTAGRAM_URL}
            aria-label="Instagram"
            className="oq-footer__social"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="mdi mdi-instagram" aria-hidden="true" />
          </a>
          <a
            href={WHATSAPP_URL}
            aria-label="WhatsApp"
            className="oq-footer__social"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="mdi mdi-whatsapp" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
